import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { ISaleMovementListItem } from '../../shared/models/sale/sale-movement-list-item';
import { ISaleMovement } from '../../shared/models/sale/sale-movement';
import {
  LegacySaleMovementResponse,
  normalizeSaleMovement,
  normalizeSaleMovementPage,
} from '../../shared/models/sale/sale-movement-adapters';

export const recordApi = createApi({
  reducerPath: 'recordApi',
  baseQuery,
  endpoints: (builder) => ({
    recordList: builder.query<IPagedResult<ISaleMovementListItem>, string>({
      query: (params) => ({
        url: `/api/records?${params}`,
        method: 'GET',
      }),
      transformResponse: normalizeSaleMovementPage,
    }),
    getRecordById: builder.query<ISaleMovement, string>({
      query: (id) => ({
        url: `/api/external-sales/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: LegacySaleMovementResponse) => normalizeSaleMovement(response),
    }),
    printPdf: builder.query<Blob, { id: string; isSaleNote: boolean }>({
      query: ({ id, isSaleNote }) => {
        const randomParam = Date.now();
        return {
          url: `/api/salemovements/${id}/${isSaleNote}?_=${randomParam}`,
          method: 'GET',
          headers: {
            Accept: 'application/pdf',
          },
          responseHandler: (response) => response.blob(),
        };
      },
    }),
  }),
});

export const { useLazyRecordListQuery, useLazyPrintPdfQuery, useLazyGetRecordByIdQuery } =
  recordApi;
